import React from "react";
import PageFooter from "../../../../../../app/js/components/loggedout/Footer/index";
import * as S from "./style";

const Footer = () => {
  return (
    <S.FooterContainer>
      <PageFooter />
    </S.FooterContainer>
  )
}

export default Footer;